export default __webpack_public_path__ + "static/media/pj-jogo-naves.e6348857.png";